import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useConsent } from '../contexts/ConsentContext'

// Shared label style for Settings / Accept all / Privacy notice (per design tokens)
const labelStyle = {
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '14px',
  color: '#FFFFFF',
}

const textBtnStyle = {
  ...labelStyle,
  display: 'block',
  width: '100%',
  background: 'none',
  border: 'none',
  padding: '2px 0',
  textAlign: 'center',
  cursor: 'pointer',
}

const acceptBtnStyle = {
  ...labelStyle,
  width: '100%',
  height: '32px',
  borderRadius: '12px',
  border: 'none',
  background: 'linear-gradient(98.81deg, #B14CEE 6.57%, #8049F3 100%)',
  boxShadow: '0px 1px 4.22px 0px #681AC74E, 0px 5px 26px 0px #681AC79C',
  cursor: 'pointer',
}

export default function CookieBanner() {
  const { cookiesAccepted, setCookiesAccepted, applyConsent } = useConsent()
  const [mounted, setMounted] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    setMounted(true)
  }, [])

  // Hidden once a choice is made, and never shown on the cookie manager page itself.
  if (!mounted || cookiesAccepted !== undefined || location.pathname.endsWith('/cookie-manager')) return null

  return (

    <div
      id='accept-cookies-popup'
      style={{
        position: 'fixed',
        left: '50%',
        bottom: '20px',
        transform: 'translateX(-50%)',
        width: 'calc(100% - 16px)',
        maxWidth: '400px',
        zIndex: 60,
        isolation: 'isolate',
        fontFamily: 'Poppins, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        textAlign: 'left',
        padding: '14px 16px',
        borderRadius: '12px',
        background:
          'radial-gradient(72.46% 2094.65% at 8.56% 0%, rgba(244, 235, 255, 0.16) 0%, rgba(235, 235, 255, 0.06) 100%), rgba(20, 15, 30, 0.55)',
        backdropFilter: 'blur(22px) saturate(1.4)',
        WebkitBackdropFilter: 'blur(22px) saturate(1.4)',
        border: '1px solid #FFFFFF1F',
        boxShadow: '0px 0px 20.78px 0px #00000017, 0px 0px 127.88px 0px #0000002E',
      }}
    >
      <span style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 500, fontSize: '14px', lineHeight: '140%', color: '#D9D1DC' }}>
        {t('cookie_title')}
      </span>
      <span style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 500, fontSize: '12px', lineHeight: '18px', color: '#D9D1DC' }}>
        {t('cookie_text')}
      </span>

      <button
        type='button'
        onClick={() => setCookiesAccepted(true)}
        style={textBtnStyle}
      >
        {t('cookieManager.onlyNecessary')}
      </button>

      <button type='button' onClick={() => setCookiesAccepted(true)} style={acceptBtnStyle}>
        {t('cookie_accept_all')}
      </button>

      <button
        type='button'
        onClick={() => navigate('/cookie-manager', { state: { fromBodyClass: document.body.className } })}
        style={textBtnStyle}
      >
        {t('cookie_manage')}
      </button>
    </div>
  )
}
